// @flow
import React, { useContext, type Node } from 'react';
import cx from 'classnames';
import { LayoutControlContext } from './DetailedAvailabilityPageLayout'

type PropTypes = {
    isItinerary?: boolean,
    children: Node,
};

const DetailedAvailabilityPageSide = ({
    isItinerary,
    children,
}: PropTypes) => {
    const {
        isFullView,
        isMobileApp,
    } = useContext(LayoutControlContext);

    return (
        <section
            className={cx('per-availability-aside', {
                'hide': isFullView,
                'mobile-app': isMobileApp,
                'itinerary': isItinerary,
            })}
            role="complementary"
        >
            {children}
        </section>
    )
}

export default DetailedAvailabilityPageSide;